import {
 OrderDetails,
 OrderHistory,
 OrderProduct,
 OrderShow,
 Product,
 ProductCategory,
 ProductProperty,
 ProductPropertyValue,
 SelectedProductProperty,
 SubCategory,
 userReview,
 Wishlist,
} from '../interface/interfaces';

export function productsAdapter(data: any[]): Product[] {
 let resp: Product[] = [];

 data.forEach((element) => {
  let newObj = {
   name: element.name,
   reviews: element.reviews.length,
   categories: [element.category, element.sub_category],
   imgUrl: element.image[0],
   productId: element.id,
   availableQuantity: element.quantity,
   isAvailable: element.quantity > 1 ? true : false,
   price_data:
    element.discount_price < element.price &&
    element.discount_price > 0
     ? {
        currency_symbol: '₦',
        current_price: element.discount_price,
        prev_price: element.price,
       }
     : {
        currency_symbol: '₦',
        current_price: element.price,
       },
   defaultProps: [],
   id: element.id,
   textDescription: element.description,
   weight: element.weight,
   discount_price: element.discount_price,
   price: element.price,
   reviewsData: element.reviews,
   isLiked: false,
   isLiking: false,
   wishlistId: null,
  };

  resp.push(newObj);
 });

 return resp;
}

export function categoriesAdapter(data: any[]): ProductCategory[] {
 let categories: ProductCategory[] = [];

 data.forEach((element) => {
  let newSubcategory: SubCategory[] = [];

  element.sub_categories.forEach((sub_elem: any) => {
   let newObj = {
    subcategory_id: sub_elem.id,
    tag: sub_elem.name.toLowerCase().trim(),
    name: sub_elem.name,
    isSelected: false,
   };

   newSubcategory.push(newObj);
  });

  let newObj = {
   category_id: element.id,
   tag: element.name.toLowerCase().trim(),
   name: element.name,
   isSelected: false,
   subCategory: newSubcategory,
  };

  categories.push(newObj);
 });

 return categories;
}

export function productDetailAdapter(data: any) {
 let productProperties: ProductProperty[] = [];

 let sizeProp: ProductProperty = {
  name: 'Size',
  values: [],
  type: 'size',
 };

 data.size.forEach((val: any) => {
  let obj: ProductPropertyValue = {
   name: val.name,
   value: val.code,
   isSelected: false,
  };

  sizeProp.values.push(obj);
 });

 if (sizeProp.values.length >= 1) {
  productProperties.push(sizeProp);
 }

 let colorProp: ProductProperty = {
  name: 'Color',
  values: [],
  type: 'color',
 };

 data.color.forEach((val: any) => {
  let obj: ProductPropertyValue = {
   name: val.name,
   value: val.code,
   isSelected: false,
  };

  colorProp.values.push(obj);
 });

 if (colorProp.values.length >= 1) {
  productProperties.push(colorProp);
 }

 function calculateAverageRating(
  ratings: number[],
  maxRating: number = 5,
 ) {
  const total = ratings.reduce((sum, rating) => sum + rating, 0);
  const count = ratings.length;

  if (count === 0 || maxRating === 0) {
   return {
    decimal: {
     average: 0,
     normalized: 0,
     percentage: 0,
    },
    floored: {
     average: 0,
     normalized: 0,
     percentage: 0,
    },
   };
  }

  const average = total / count;
  const normalized = average; // already in same scale
  const percentage = (average / maxRating) * 100;

  return {
   decimal: {
    average: parseFloat(average.toFixed(2)),
    normalized: parseFloat(normalized.toFixed(2)),
    percentage: parseFloat(percentage.toFixed(2)),
   },
   floored: {
    average: Math.floor(average),
    normalized: Math.floor(normalized),
    percentage: Math.floor(percentage),
   },
  };
 }

 let ratingArr: number[] = [];

 data.reviews.forEach((cv: any) => {
  ratingArr.push(cv.rating);
 });

 let stars = calculateAverageRating(ratingArr).floored.average || 0;

 return {
  name: data.name,
  reviews: data.reviews.length,
  stars: stars,
  categories: [data.category, data.sub_category],
  imgUrl: data.image[0],
  productId: data.id,
  isAvailable: data.quantity > 1 ? true : false,
  availableQuantity: data.quantity,
  price_data:
   data.discount_price <= 0
    ? {
       currency_symbol: '₦',
       current_price: data.price,
      }
    : {
       currency_symbol: '₦',
       current_price: data.discount_price,
       prev_price: data.price,
      },
  properties: productProperties,
  defaultProps: [],
  productImages: data.image,
  description: {
   text: data.description,
   features: data.product_details,
  },
  reviewDetails: {
   ratings: {
    stars: stars,
    totalStars: 5,
   },
   totalReviews: data.reviews.length,
   userReviews: [],
  },
  shippingDetails: {
   processingTime:
    'Orders are processed within 1-2 business days (excluding weekend and holidays) Once your order is confirmed, you will receive an Email notification with tracking details as soon as it ships',
   shippingOptions: [
    'Standard shipping (3-7 business days)',
    'Express shipping (1-2 business days)',
    'Local delivery (same day or next day delivery)',
    'International delivery (7-14 business days)',
   ],
   orderTracking:
    'Once your order is shipped, we will send you a tracking link via E-mail or sms. You can also track your order anytime to know live location of goods..',
   supportEmail: 'tech@yayakoexpress.com',
  },
  warranty: {
   processingTime:
    'We offer limited warranty, covering manufacturing defects and faulty materials up to 10 months of purchase.',
   coveredList: [
    'Manufacturing issues.',
    'functional defects under normal use.',
   ],
   notCoveredList: [
    'Accidental damage.',
    'Wear and tear.',
    'Unauthorized repairs',
   ],
   supportEmail: 'tech@yayakoexpress.com',
  },
  returnPolicy: {
   steps: [
    'Email us at tech@yayakoexpress.com or chat us live on weekdays from 9am - 6pm',
    'We’ll send you return instructions within 1- 2 business days',
    'Once received and inspected, we’ll process your refund or exchange or refund',
   ],
  },
  vendor: data.vendor,
 };
}

export function userReviewsAdapter(data: any[]) {
 let userReviews: userReview[] = [];

 data.forEach((ev) => {
  let obj = {
   userName: ev.customer.name,
   userImgUrl: ev.customer.image,
   timePurchased: ev.date_created,
   comment: ev.comment,
   starRatings: {
    stars: ev.rating,
    totalStars: 5,
   },
  };

  userReviews.push(obj);
 });

 return userReviews;
}

export function cartItemsAdapter(data: any[]) {
 let return_array: OrderDetails[] = [];

 data.forEach((elem) => {
  let selectedProp: SelectedProductProperty[] = [];

  if (elem.size && elem.size !== '') {
   let sizeProp = {
    name: 'Size',
    type: 'size',
    value: elem.size,
    value_name: elem.size,
   };

   selectedProp.push(sizeProp);
  }

  if (elem.color && elem.color !== '') {
   let colorProp = {
    name: 'Color',
    type: 'color',
    value: elem.color,
    value_name: elem.color,
   };

   selectedProp.push(colorProp);
  }

  let obj: OrderDetails = {
   id: elem.id,
   productId: elem.product_id,
   productName: elem.product_name,
   imgUrl: elem.product_image[0],
   quantity: elem.quantity,
   selectedProperties: selectedProp,
   totalAmount: elem.total_price,
   isAvailable: true,
   maxQuantity: 9999,
   isUpdating: false,
   priceData:
    elem.discount_price <= 0
     ? {
        currency_symbol: '₦',
        current_price: elem.product_price,
       }
     : {
        currency_symbol: '₦',
        current_price: elem.discount_price,
        prev_price: elem.product_price,
       },
  };

  return_array.push(obj);
 });

 return return_array;
}

export function OrderShowAdapter(data: OrderHistory[]) {
 if (data.length <= 0) {
  throw Error('Invalid Order Id');
 }

 let productsData: OrderProduct[] = [];

 data.forEach((eachdata) => {
  let selectedProp: SelectedProductProperty[] = [];

  if (eachdata.size && eachdata.size !== '') {
   let sizeProp = {
    name: 'Size',
    type: 'size',
    value: eachdata.size,
    value_name: eachdata.size,
   };

   selectedProp.push(sizeProp);
  }

  if (eachdata.color && eachdata.color !== '') {
   let colorProp = {
    name: 'Color',
    type: 'color',
    value: eachdata.color,
    value_name: eachdata.color,
   };

   selectedProp.push(colorProp);
  }

  let obj = {
   id: eachdata.id,
   product_id: eachdata.product_id,
   product_name: eachdata.product_name,
   product_image: eachdata.product_image,
   quantity: eachdata.quantity,
   amount: eachdata.amount,
   selectedProperties: selectedProp,
   order_timeline: eachdata.order_timeline,
  };

  productsData.push(obj);
 });

 let obj: OrderShow = {
  id: data[0].id,
  order_id: data[0].order_id,
  customer_id: data[0].customer_id,
  customer_email: data[0].customer_email,
  customer_name: data[0].customer_name,
  customer_first_name: data[0].customer_first_name,
  customer_last_name: data[0].customer_last_name,
  customer_telephone_no: data[0].customer_telephone_no,
  delivery_address: data[0].delivery_address,
  delivery_price: data[0].delivery_price,
  transaction_status: data[0].transaction_status,
  payment_method: data[0].payment_method,
  order_date: data[0].order_date,
  createdAt: data[0].createdAt,
  updatedAt: data[0].updatedAt,
  status: data[0].status,
  products: productsData,
 };

 return obj;
}

// export function OrderHistoryDetailAdapter(
//   data: OrderHistory
// ): OrderHistoryDetail {
//   let selectedProp: SelectedProductProperty[] = [];

//   if (data.size && data.size !== "") {
//     let sizeProp = {
//       name: "Size",
//       type: "size",
//       value: data.size,
//       value_name: data.size,
//     };

//     selectedProp.push(sizeProp);
//   }

//   if (data.color && data.color !== "") {
//     let colorProp = {
//       name: "Color",
//       type: "color",
//       value: data.color,
//       value_name: data.color,
//     };

//     selectedProp.push(colorProp);
//   }

//   return {
//     ...data,
//     selectedProperties: selectedProp,
//   };
// }

export function wishlistAdapter(data: any[]) {
 let return_array: Wishlist[] = [];

 data.forEach((d) => {
  let newObj = {
   ...d,
   addLoader: false,
   deleteLoader: false,
  };

  return_array.push(newObj);
 });

 return return_array;
}

export function ReturnedOrderAdapter(data: any[]): OrderShow {
 if (data.length <= 0) {
  throw Error('Invalid Order Id');
 }

 let productsData: OrderProduct[] = [];

 data.forEach((eachdata) => {
  let selectedProp: SelectedProductProperty[] = [];

  if (eachdata.size && eachdata.size !== '') {
   let sizeProp = {
    name: 'Size',
    type: 'size',
    value: eachdata.size,
    value_name: eachdata.size,
   };

   selectedProp.push(sizeProp);
  }

  if (eachdata.color && eachdata.color !== '') {
   let colorProp = {
    name: 'Color',
    type: 'color',
    value: eachdata.color,
    value_name: eachdata.color,
   };

   selectedProp.push(colorProp);
  }

  let obj = {
   id: eachdata.id,
   product_id: eachdata.product_id,
   product_name: eachdata.product_name,
   product_image: eachdata.product_image,
   quantity: eachdata.quantity,
   amount: eachdata.amount,
   selectedProperties: selectedProp,
   order_timeline: eachdata.order_timeline,
  };

  productsData.push(obj);
 });

 let obj: OrderShow = {
  id: data[0].id,
  order_id: data[0].order_id,
  customer_id: data[0].customer_id,
  customer_email: data[0].customer_email,
  customer_name: data[0].customer_name,
  customer_first_name: data[0].customer_first_name,
  customer_last_name: data[0].customer_last_name,
  customer_telephone_no: data[0].customer_telephone_no,
  delivery_address: data[0].delivery_address,
  delivery_price: data[0].delivery_price,
  transaction_status: data[0].transaction_status,
  payment_method: data[0].payment_method,
  order_date: data[0].order_date,
  createdAt: data[0].createdAt,
  updatedAt: data[0].updatedAt,
  status: data[0].status,
  products: productsData,
 };

 return obj;
}
